import * as React from 'react';
import BookOutlined from '@material-ui/icons/BookOutlined';
import { fetchTrainingComplianceCount } from 'slices/trainingCompliance';
import { ToDoDescriptor } from '../types';
import { useAppDispatch, useTypedSelector } from '../../../../combineReducers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useTrainingComplianceToDo = (): ToDoDescriptor[] => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');
  const { count, isFetching } = useTypedSelector(state => state.trainingCompliance);

  React.useEffect(() => {
    if (organizationId) {
      dispatch(fetchTrainingComplianceCount(organizationId));
    }
  }, [organizationId, dispatch]);

  const complianceCount = count ?? 0;

  return [
    {
      id: 'trainingCompliance',
      variant: 'link',
      label: t('newDashboard.toDoWidget.reviewTrainingCompliance', 'Review Training Compliance', {
        count: complianceCount
      }),
      icon: <BookOutlined />,
      href: `/organizations/${organizationId}/training-compliance`,
      isVisible: complianceCount > 0,
      isFetching
    }
  ];
};
